/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sign_In_SubInputs */

const th_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เราจะส่งรหัสไปที่อีเมลของคุณ ไม่ต้องใช้รหัสผ่าน`)
};

const en_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We'll email you a code — no password needed`)
};

const ja_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認証コードをメールでお送りします。パスワードは不要です。`)
};

const zh_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们会通过邮件发给你一个验证码——无需密码`)
};

const es_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te enviaremos un código por correo: no hace falta contraseña`)
};

const pt_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviaremos um código por e-mail — sem senha`)
};

const id_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami kirimkan kode lewat email — tanpa kata sandi`)
};

const fr_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous vous enverrons un code par e-mail — pas de mot de passe`)
};

const tl_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padadalhan ka namin ng code sa email — walang password`)
};

const vi_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chúng tôi gửi bạn một mã qua email — không cần mật khẩu`)
};

const ko_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일로 코드를 보내드립니다 — 비밀번호는 필요 없습니다`)
};

const de_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir schicken dir einen Code per E-Mail — kein Passwort nötig`)
};

const ru_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы пришлём вам код на почту — пароль не нужен`)
};

const tr_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size e-postayla bir kod göndeririz — parola gerekmez`)
};

const it_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti inviamo un codice via email — nessuna password`)
};

const pl_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślemy ci kod e-mailem — bez hasła`)
};

const uk_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ми надішлемо вам код поштою — пароль не потрібен`)
};

const hi_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हम आपको ईमेल पर एक कोड भेजेंगे — पासवर्ड की ज़रूरत नहीं`)
};

const ar_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سنرسل لك رمزًا بالبريد — بلا كلمة مرور`)
};

const ms_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami hantar kod melalui e-mel — tiada kata laluan`)
};

const bn_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আমরা ইমেলে একটি কোড পাঠাব — পাসওয়ার্ড লাগবে না`)
};

const zh_tw2_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們會以電子郵件寄給你一組驗證碼——不需要密碼`)
};

const zh_hk2_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們會以電子郵件寄給你一組驗證碼——不需要密碼`)
};

const ur_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ہم آپ کو ای میل پر ایک کوڈ بھیجیں گے — پاس ورڈ کی ضرورت نہیں`)
};

const fa_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کدی با ایمیل برایتان می‌فرستیم — گذرواژه لازم نیست`)
};

const sw_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutakutumia msimbo kwa barua pepe — hakuna nywila`)
};

const nl_sign_in_sub = /** @type {(inputs: Sign_In_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We sturen je een code per e-mail — geen wachtwoord nodig`)
};

/**
* | output |
* | --- |
* | "We'll email you a code — no password needed" |
*
* @param {Sign_In_SubInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const sign_in_sub = /** @type {((inputs?: Sign_In_SubInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_In_SubInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_sign_in_sub(inputs)
	if (locale === "ja") return ja_sign_in_sub(inputs)
	if (locale === "zh") return zh_sign_in_sub(inputs)
	if (locale === "es") return es_sign_in_sub(inputs)
	if (locale === "pt") return pt_sign_in_sub(inputs)
	if (locale === "id") return id_sign_in_sub(inputs)
	if (locale === "fr") return fr_sign_in_sub(inputs)
	if (locale === "tl") return tl_sign_in_sub(inputs)
	if (locale === "vi") return vi_sign_in_sub(inputs)
	if (locale === "ko") return ko_sign_in_sub(inputs)
	if (locale === "de") return de_sign_in_sub(inputs)
	if (locale === "ru") return ru_sign_in_sub(inputs)
	if (locale === "tr") return tr_sign_in_sub(inputs)
	if (locale === "it") return it_sign_in_sub(inputs)
	if (locale === "pl") return pl_sign_in_sub(inputs)
	if (locale === "uk") return uk_sign_in_sub(inputs)
	if (locale === "hi") return hi_sign_in_sub(inputs)
	if (locale === "ar") return ar_sign_in_sub(inputs)
	if (locale === "ms") return ms_sign_in_sub(inputs)
	if (locale === "bn") return bn_sign_in_sub(inputs)
	if (locale === "zh-TW") return zh_tw2_sign_in_sub(inputs)
	if (locale === "zh-HK") return zh_hk2_sign_in_sub(inputs)
	if (locale === "ur") return ur_sign_in_sub(inputs)
	if (locale === "fa") return fa_sign_in_sub(inputs)
	if (locale === "sw") return sw_sign_in_sub(inputs)
	if (locale === "nl") return nl_sign_in_sub(inputs)
	return en_sign_in_sub(inputs)
});